import http from '@/utils/http'
import { logError } from '@/utils/logger'
import { ElMessage } from 'element-plus'

const PER_PAGE = 15

const initialState = () => ({
  list: []
})

export const state = initialState()

export const mutations = {
  RESET (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  },
  SET_LIST (state, list) {
    state.list = list
  }
}

export const getters = {
  list: state => state.list,
  itemsPerPage: () => PER_PAGE,
  total: state => (state.list[0] && state.list[0].TotalRows) || 0
}

export const actions = {
  fetchFiles ({ commit, rootGetters }, { jobId, page = 1, stateId = -1, filter = {} }) {
    const data = {
      FileStatus: stateId,
      JobID: jobId,
      PageSize: PER_PAGE,
      PageStart: page,
      ...filter
    }

    return http({
      method: 'post',
      url: `${process.env.VUE_APP_API_URL}DAS/data/retrieve/files/${rootGetters['auth/token']}`,
      data
    }).then(list => {
      commit('SET_LIST', list)

      return list
    }).catch(e => {
      ElMessage.warning('Error loading job sets')

      logError(e, { data }, 'jobFiles: error loading job files')

      throw e
    })
  },
  updateStatuses ({ commit, rootGetters }, { newStatusId, ids = [] }) {
    return http({
      method: 'post',
      url: `${process.env.VUE_APP_API_URL}DAS/data/set/file/status/${rootGetters['auth/token']}/${newStatusId}/${rootGetters['customers/customerGuid']}`,
      data: ids
    }).catch(e => {
      ElMessage.error('Error changing statuses')

      throw e
    })
  }
}
